import React from "react";
import { Info, CheckCircle2, AlertTriangle, XOctagon } from "lucide-react";

const ICONS = {
  neutral: Info, info: Info, success: CheckCircle2, warning: AlertTriangle, danger: XOctagon,
};

/**
 * ─── Callout ──────────────────────────────────────────────────────────────
 * Inline alert with tone-tinted background. Persistent (not a Toast).
 *
 * Props
 *   tone      "neutral" | "info" | "success" | "warning" | "danger"
 *   title     string           — optional bold headline
 *   icon      ReactNode         — override the default lucide icon
 *   actions   ReactNode         — right-aligned actions inside the callout
 *   testId
 *   children  the message body
 */
export default function Callout({ tone = "neutral", title, icon, actions, children, testId }) {
  const cn = ["ds-callout", tone !== "neutral" && `ds-callout--${tone}`].filter(Boolean).join(" ");
  const Icon = ICONS[tone] || Info;
  return (
    <div className={cn} role={tone === "danger" || tone === "warning" ? "alert" : "status"} data-testid={testId}>
      <span className="ds-callout__icon" aria-hidden>
        {icon || <Icon size={16} strokeWidth={2.2} />}
      </span>
      <div className="ds-callout__body">
        {title && <div className="ds-callout__title">{title}</div>}
        <div className="ds-callout__desc">{children}</div>
      </div>
      {actions && <div style={{ flex: "none" }}>{actions}</div>}
    </div>
  );
}
